import { render, staticRenderFns } from "./TeachingQuestionForm.vue?vue&type=template&id=09d749c3&scoped=true"
import script from "./TeachingQuestionForm.vue?vue&type=script&lang=js"
export * from "./TeachingQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./TeachingQuestionForm.vue?vue&type=style&index=0&id=09d749c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d749c3",
  null
  
)

export default component.exports